module.exports = __webpack_public_path__ + "static/media/company7.011c3d68.png";